import { ModalLayout } from '@components/Layouts'
import { GarminFinish, GarminStart } from '@components/Settings/Garmin'
import { useI18n } from '@lib/i18n'
import { Route, useRoute } from '@react-navigation/native'
import { RouteName } from 'src/router/routeNames'

export function GarminModal() {
  const t = useI18n()
  const { params } =
    useRoute<
      Route<RouteName.GarminModal, { oauth_token: string; oauth_verifier: string | null; status: 'start' | 'finish' }>
    >()

  return (
    <ModalLayout title={t('settings.garmin.watch')} hasCancel={params.status === 'start'}>
      {params.status === 'start' && <GarminStart />}
      {params.status === 'finish' && <GarminFinish token={params.oauth_token} verifier={params.oauth_verifier} />}
    </ModalLayout>
  )
}
